import { defineComponent as z, computed as i, openBlock as o, createElementBlock as p, normalizeClass as E, createVNode as y, unref as m, createCommentVNode as r, createBlock as S, Fragment as b, createTextVNode as d, toDisplayString as l, renderSlot as v } from "vue";
import { EChipVariants as I, EChipSizes as B, EChipEmphasis as _, EChipShapes as g } from "./novoui-vuejs77.js";
import { getFilterChipPrependedIconSize as V, getFilterChipStyleClasses as j } from "./novoui-vuejs78.js";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import a from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
const F = ["disabled"], N = {
  key: 0,
  class: "chip-filter-prepend-container"
}, $ = {
  key: 1,
  class: "chip-filter-prepend-container"
}, Ee = /* @__PURE__ */ z({
  __name: "NFilterChip",
  props: {
    variant: { default: I.fill },
    size: { default: B.md },
    prependedIcon: {},
    prependedEmoji: {},
    disabled: { type: Boolean, default: !1 },
    emphasis: { default: _.default },
    shape: { default: g.rounded },
    label: {},
    selected: { type: Boolean }
  },
  emits: [
    /**
     * The event emitted on selected change
     */
    "update:selected"
  ],
  setup(c, { emit: u }) {
    const f = u, t = c, n = i({
      get: () => t.selected,
      set: (e) => {
        f("update:selected", e);
      }
    }), h = () => {
      n.value = !n.value;
    }, C = i(() => t.prependedEmoji || t.prependedIcon), s = i(() => V(t.size)), k = i(() => j(t));
    return (e, D) => (o(), p("button", {
      class: E(k.value),
      disabled: e.disabled,
      onClick: h
    }, [
      e.selected ? (o(), p("span", N, [
        y(m(a), {
          icon: "tick",
          size: s.value
        }, null, 8, ["size"])
      ])) : r("", !0),
      C.value && !e.selected ? (o(), p("span", $, [
        e.prependedIcon ? (o(), S(m(a), {
          key: 0,
          icon: t.prependedIcon,
          size: s.value
        }, null, 8, ["icon", "size"])) : r("", !0),
        e.prependedEmoji && !e.prependedIcon ? (o(), p(b, { key: 1 }, [
          d(l(t.prependedEmoji), 1)
        ], 64)) : r("", !0)
      ])) : r("", !0),
      v(e.$slots, "default", {}, () => [
        d(l(e.label), 1)
      ])
    ], 10, F));
  }
});
export {
  Ee as default
};
